import { useSearchParams } from 'wouter';

import { FilePreview } from './FilePreview';

export const FileDetailsView = () => {
  const [searchParams] = useSearchParams();
  const fileId = searchParams.get('fileId');

  return fileId ? <FilePreview fileId={fileId} /> : null;
};
